"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSymbol = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _fontfaceobserver = _interopRequireDefault(require("fontfaceobserver"));
var _styled = require("../../tools/styled");
var _useAbyssProps = require("../../hooks/useAbyssProps");
var _useCssProps = require("../../hooks/useCssProps");
var _excluded = ["isScreenReadable", "icon", "variant", "title", "color", "size", "sizes"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var appendFont = function appendFont() {
  var elementId = 'abyss-google-material-symbols';
  if (!document.getElementById(elementId)) {
    var styleElement = document.createElement('link');
    document.head.appendChild(styleElement);
    styleElement.id = elementId;
    styleElement.rel = 'stylesheet';
    styleElement.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
  }
};
var StyledIconSymbol = (0, _styled.styled)('span', {
  "static": {
    '&.material-symbols-outlined': {
      fontVariationSettings: {
        FILL: 0,
        wght: 400,
        GRAD: 0,
        opsz: 24
      }
    }
  },
  dynamic: function dynamic(_ref) {
    var cssProps = _ref.cssProps;
    var size = cssProps.size,
      color = cssProps.color,
      variant = cssProps.variant;
    var fill = variant === 'filled' ? 1 : 0;
    var iconSize = size ? String(size).replace(/px$/, '') : '24';
    return {
      '&.material-symbols-outlined': {
        color: color,
        fontSize: size,
        fontVariationSettings: "'FILL' ".concat(fill, ", 'wght' 400, 'GRAD' 0, 'opsz' ").concat(iconSize)
      }
    };
  }
});
var IconSymbol = function IconSymbol(_ref2) {
  var isScreenReadable = _ref2.isScreenReadable,
    icon = _ref2.icon,
    variant = _ref2.variant,
    title = _ref2.title,
    color = _ref2.color,
    size = _ref2.size,
    sizes = _ref2.sizes,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var abyssProps = (0, _useAbyssProps.useAbyssProps)(props);
  var cssProps = (0, _useCssProps.useCssProps)({
    color: color,
    size: size,
    sizes: sizes
  });
  var _useState = (0, _react.useState)(false),
    fontLoaded = _useState[0],
    setFontLoaded = _useState[1];
  (0, _react.useEffect)(function () {
    appendFont();
    var fontObserver = new _fontfaceobserver["default"]('Material Symbols Outlined', {
      timeout: 5000
    });
    fontObserver.load().then(function () {
      setFontLoaded(true);
    })["catch"](function (error) {
      console.error('IconSymbol Font loading failed', error);
      setFontLoaded(true);
    });
  }, []);
  if (!icon || !fontLoaded) {
    return null;
  }
  return __jsx(StyledIconSymbol, (0, _extends2["default"])({}, props, abyssProps(['icon-symbol', 'icon'], {
    className: 'material-symbols-outlined'
  }), {
    role: isScreenReadable ? 'img' : null,
    "aria-hidden": !isScreenReadable,
    title: isScreenReadable ? title || icon : null,
    cssProps: _objectSpread(_objectSpread({}, cssProps), {}, {
      variant: variant
    })
  }), icon);
};
exports.IconSymbol = IconSymbol;
IconSymbol.displayName = '@abyss/web/ui/IconSymbol';
IconSymbol.defaultProps = {
  variant: 'filled',
  color: '$interactive1',
  size: 24,
  sizes: {
    xs: '12px',
    sm: '16px',
    md: '24px',
    lg: '48px',
    xl: '64px'
  },
  title: null,
  isScreenReadable: false
};